import React from 'react';
import { userConnectionPropTypes } from '../../../sharedPropTypes';
import { string } from 'prop-types';
import styles from './styles/styles.module.scss';
import { STATUS_FOLLOW_REQUESTED, LOADING } from '../../../constants';
import Button from '../../../../../components/shared/Button';
import LoadingSpinner from '../../../../../components/shared/LoadingSpinner';
import RequestedButton from '../RequestedButton';
import { useFollowRequest } from '../../../hooks/useConnectAction';

const FollowButton = ({ className, userConnection }) => {
  const followAction = useFollowRequest(userConnection);

  if (userConnection.status.includes(STATUS_FOLLOW_REQUESTED)) {
    return <RequestedButton {...userConnection.actions} className={className} userConnection={userConnection} />;
  }

  return (
    <Button classes={`${styles.container} ${className}`} variant="primary" onClick={followAction}>
      {/* as time goes on, and we recieve different requestStates' this will become a switch statement */}
      {userConnection.actions.follow.requestState === LOADING ? (
        <LoadingSpinner className={styles.loadingSpinner} />
      ) : (
        userConnection.actions.follow.title
      )}
    </Button>
  );
};

FollowButton.propTypes = {
  className: string,
  userConnection: userConnectionPropTypes.isRequired
};

FollowButton.defaultProps = {
  className: ''
};

export default FollowButton;
